import { booleanAttribute, Component, EventEmitter, HostBinding, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DropdownItem, ExDropdownComponent } from '../ex-dropdown/ex-dropdown.component';
import { SortDirEnum } from '../../models/sort';
import { DbPostSearchSort } from '../../../tenders/models/tender-search-body';

export interface SortDropdownItem extends DropdownItem {
  direction: SortDirEnum;
  unidirectional?: boolean;
  onSort?: (item: SortDropdownItem) => void;
}

@Component({
  selector: 'ex-sort-dropdown',
  templateUrl: './ex-sort-dropdown.component.html',
  styleUrls: ['./ex-sort-dropdown.component.scss'],
})
export class ExSortDropdownComponent implements OnChanges {
  @Input({ required: true }) items!: SortDropdownItem[];
  @Input() defaultValue?: DbPostSearchSort;
  @Input() headerHeight?: number;
  @Input({ transform: booleanAttribute }) useShortLabel = false;
  @Input({ transform: booleanAttribute }) invertArrowIcons = false;
  @Input({ transform: booleanAttribute }) compact = false;
  @Input({ transform: booleanAttribute }) shadowBorder = true;
  @Input() labelKey?: string;
  activeItem?: SortDropdownItem;

  @Output() sort = new EventEmitter<DbPostSearchSort>();

  @ViewChild(ExDropdownComponent) dropdown?: ExDropdownComponent;

  @HostBinding('class.ex-sort-dropdown--compact')
  get compactHostClass(): boolean {
    return this.compact;
  }

  get resolvedLabelKey(): string {
    if (this.labelKey) return this.labelKey;
    if (this.compact) return 'common.sort';
    return this.useShortLabel ? 'common.by' : 'common.sort-by';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['defaultValue'] && this.defaultValue) {
      this.activeItem = this.items.find(item => item.value === this.defaultValue?.field);
      if (this.activeItem && this.activeItem.direction !== this.defaultValue.dir) {
        this.changeState(this.activeItem);
      }
    }
  }

  changeState(item: SortDropdownItem) {
    if (item === this.activeItem && !item.unidirectional) {
      item.direction = item.direction === SortDirEnum.DESC ? SortDirEnum.ASC : SortDirEnum.DESC;
    }
    if (item.onSort) item.onSort(item);
  }

  onSort(item: SortDropdownItem) {
    const shouldClose = !!item.unidirectional;
    this.changeState(item);
    this.activeItem = item;
    this.sort.emit({ field: item.value, dir: item.direction });
    if (shouldClose) {
      this.dropdown?.toggle(false);
    }
  }
}
